import configData from '../../fields/other/configData';

export const QUERY_GET_PUBLIC_CONFIG_DATA = /* GraphQL */ `
	query($id: String!) {
		getPublicConfigData(id: $id) {
			${configData}
		}
	}
`;
